export class UserProfileMessageData {
  is_new_user: boolean;
  is_team_user: boolean;
}

export enum UserMessageEnum {
  DomainAlert = 'join_group_through_domain_alert',
  WelcomeTour = 'welcome_tour_alert',
  CompleteProfileAlert = 'complete_profile_alert',
}

export class UserMessageModel<T = any> {
  messageSeenId?: string;
  messageType: UserMessageEnum;
  messageData: T;
  showUserAlert: boolean;
}
